import React, { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import "../../../programs.css";

const curriculumData = [
  {
    title: "ML Foundations & Intelligent Systems",
    description:
      "Introduction to Machine Learning, ML workflow & lifecycle, Types of ML: Supervised, Unsupervised, Reinforcement, ML applications & use cases",
  },
  {
    title: "Python Programming for ML",
    description:
      "Python basics for ML, NumPy, Pandas, Matplotlib, Data manipulation & cleaning, EDA with real datasets",
  },
  {
    title: "Mathematical & Statistical Intelligence",
    description:
      "Linear algebra for ML, Probability & statistics, Gradient, derivatives & optimization basics, Data distribution understanding",
  },
  {
    title: "Supervised Learning Algorithms",
    description:
      "Linear & Logistic Regression, Decision Trees & Random Forests, SVM (Support Vector Machine), KNN, Naive Bayes",
  },
  {
    title: "Unsupervised Learning & Pattern Mining",
    description:
      "K-Means Clustering, Hierarchical Clustering, PCA & dimensionality reduction, Anomaly detection",
  },
  {
    title: "Model Evaluation & Performance Optimization",
    description:
      "Train-test split & cross-validation, Accuracy, Precision, Recall, F1 Score, Confusion matrix, ROC-AUC, Hyperparameter tuning (Grid/Random Search)",
  },
  {
    title: "Feature Engineering & Data Processing",
    description:
      "Missing value handling, Scaling & normalization, Encoding techniques, Feature selection & dimensionality reduction",
  },
  {
    title: "ML Pipelines & Automation",
    description:
      "Building ML pipelines, Model versioning, Workflow automation, Scalable pipeline architecture",
  },
  {
    title: "Deployment & MLOps Fundamentals",
    description:
      "Model deployment on cloud, REST API integration, CI/CD basics, Monitoring & model updates",
  },
  {
    title: "Capstone ML Project & Career Launchpad",
    description:
      "Real-world ML project, Full workflow: data → model → deploy, Portfolio building, Resume + interview preparation",
  },
];

const ProgramCurriculum = () => {
  const [activeIndex, setActiveIndex] = useState(null);

  const toggleSection = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  return (
    <div className="curriculum-container">
      <motion.h2
        className="curriculum-heading"
        initial={{ opacity: 0, y: -30 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6 }}
      >
        Program Curriculum
      </motion.h2>
      <motion.p
        className="curriculum-subtext"
        initial={{ opacity: 0 }}
        whileInView={{ opacity: 1 }}
        transition={{ delay: 0.2, duration: 0.6 }}
      >
        This curriculum is structured in a practical and progressive format so
        you can learn step-by-step from zero to advanced level — and build
        real-world applications.
      </motion.p>
      <div className="curriculum-list">
        {curriculumData.map((item, index) => (
          <motion.div
            key={index}
            className="curriculum-item"
            onClick={() => toggleSection(index)}
            whileHover={{ x: 10 }}
            transition={{ duration: 0.3 }}
          >
            <div className="title-row">
              <span className="curriculum-title">{item.title}</span>
              <motion.span
                animate={{ rotate: activeIndex === index ? 90 : 0 }}
                transition={{ duration: 0.3 }}
                className="arrow"
              >
                ➤
              </motion.span>
            </div>
            <AnimatePresence>
              {activeIndex === index && (
                <motion.p
                  className="curriculum-description"
                  initial={{ opacity: 0, height: 0 }}
                  animate={{ opacity: 1, height: "auto" }}
                  exit={{ opacity: 0, height: 0 }}
                  transition={{ duration: 0.4 }}
                >
                  {item.description}
                </motion.p>
              )}
            </AnimatePresence>
          </motion.div>
        ))}
      </div>
    </div>
  );
};

export default ProgramCurriculum;
